"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInOutAnimation = createInOutAnimation;
exports.InnerInOutAnimation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Transition = _interopRequireDefault(require("react-transition-group/Transition"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useResizeObserver2 = _interopRequireDefault(require("use-resize-observer"));

var _useForwardRef3 = require("../utils/useForwardRef");

var _useMountedRef = require("../utils/useMountedRef");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var InnerInOutAnimation = _styledComponents.default.div.withConfig({
  displayName: "InOutAnimation__InnerInOutAnimation",
  componentId: "sc-1oofmag-0"
})(["", " ", ""], function (props) {
  return props.baseStyles;
}, function (_ref) {
  var state = _ref.state,
      enterStyles = _ref.enterStyles,
      exitStyles = _ref.exitStyles;

  switch (state) {
    case 'entered':
    case 'entering':
      return enterStyles;

    case 'exited':
      return exitStyles;

    default:
      return null;
  }
});

exports.InnerInOutAnimation = InnerInOutAnimation;
var InOutAnimation = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var visible = _ref2.visible,
      onExited = _ref2.onExited,
      duration = _ref2.duration,
      children = _ref2.children,
      additionalProps = _objectWithoutProperties(_ref2, ["visible", "onExited", "duration", "children"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      animationIn = _useState2[0],
      setAnimationIn = _useState2[1];

  var _useForwardRef = (0, _useForwardRef3.useForwardRef)(ref),
      _useForwardRef2 = _slicedToArray(_useForwardRef, 2),
      innerRef = _useForwardRef2[0],
      setInnerRef = _useForwardRef2[1];

  var mountedRef = (0, _useMountedRef.useMountedRef)();

  var _useResizeObserver = (0, _useResizeObserver2.default)({
    ref: innerRef
  }),
      width = _useResizeObserver.width,
      height = _useResizeObserver.height;

  _react.default.useEffect(function () {
    var requestCallback = window.requestIdleCallback || requestAnimationFrame || setTimeout;
    requestCallback(function () {
      return mountedRef.current && setAnimationIn(visible);
    });
  }, [visible, mountedRef]);

  return /*#__PURE__*/_react.default.createElement(_Transition.default, {
    in: animationIn,
    timeout: duration,
    onExited: onExited
  }, function (state) {
    return /*#__PURE__*/_react.default.createElement(InnerInOutAnimation, _extends({
      ref: setInnerRef,
      "data-testid": "pbl-animation-inner",
      duration: duration,
      selfWidth: width,
      selfHeight: height,
      state: state
    }, additionalProps), children);
  });
});

function createInOutAnimation(_ref3) {
  var baseStyles = _ref3.baseStyles,
      enterStyles = _ref3.enterStyles,
      exitStyles = _ref3.exitStyles;
  return /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    return /*#__PURE__*/_react.default.createElement(InOutAnimation, _extends({
      ref: ref,
      baseStyles: baseStyles,
      enterStyles: enterStyles,
      exitStyles: exitStyles
    }, props));
  });
}